export default (value) => {
  return /^[0-9]+$/.test(String(value))
}


// WEBPACK FOOTER //
// ./src/validator/numberic.js